export default {
  APP_SET_ENTITY_ID: "APP_SET_ENTITY_ID",
  SET_GLOBAL_DASHBOARD_DATA: "SET_GLOBAL_DASHBOARD_DATA",
  SET_GLOBAL_FILTER_DATA: "SET_GLOBAL_FILTER_DATA",
  SET_GLOBAL_FILTER_MULTI_DATA: "SET_GLOBAL_FILTER_MULTI_DATA",
  SET_DASHBOARD_REPORT_DATA: "SET_DASHBOARD_REPORT_DATA",
  RESET_DASHBOARD_DATA: "RESET_DASHBOARD_DATA",
};
